import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for migrated `/trade-partners/*` URLs.
 *
 * Kept separate from `tradePartners.ts` (the `RouteObject` tree) so `RouteUrls.ts` and pages can
 * import paths without creating a cycle through page `Component` imports.
 *
 * Nested routes compose from their parent's `.path` so the hierarchy stays visible and absolute
 * strings stay in sync (RR6 requires a child's path to start with its parent's).
 */
export const tradePartnersRoute = defineRoute("/trade-partners");
export const tradePartnerRoute = defineRoute(`${tradePartnersRoute.path}/:idOrAdd`);
export const tradePartnerDetailsRoute = defineRoute(`${tradePartnerRoute.path}/details`);
export const tradePartnerContactsRoute = defineRoute(`${tradePartnerRoute.path}/contacts`);
export const tradePartnerContactRoute = defineRoute(`${tradePartnerContactsRoute.path}/:tpContactId`);
export const tradePartnerReviewsRoute = defineRoute(`${tradePartnerRoute.path}/reviews`);
export const tradePartnerCommitmentsRoute = defineRoute(`${tradePartnerRoute.path}/commitments`);
export const tradePartnerDevelopmentContractsRoute = defineRoute(`${tradePartnerRoute.path}/development-contracts`);
export const tradePartnerRequirementsRoute = defineRoute(`${tradePartnerRoute.path}/requirements`);
export const paymentTermsRoute = defineRoute(`${tradePartnersRoute.path}/payment-terms`);
export const tradeCategoryLeadTimesRoute = defineRoute(`${tradePartnersRoute.path}/tradeCategoryLeadTimes`);

/** Convenience alias matching the legacy `routesDef` export name. */
export const tradePartnersPath = tradePartnersRoute.path;
